


import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastController } from '@ionic/angular';
// import { index, linkHorizontal } from 'd3';

import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { AssetSelectRendererComponent } from '../asset-select-renderer/asset-select-renderer.component';
import { NgZone } from '@angular/core';


interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-new-asset-employee',
  templateUrl: './new-asset-employee.component.html',
  styleUrls: ['./new-asset-employee.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class NewAssetEmployeeComponent implements OnInit, OnDestroy {
  // event listener ref for global allocate events
  private _allocateEventListener: any;
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  todayDate: any;
  datedisplay: any
  isReadOnly = true;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  dropdownSettings: IDropdownSettings = {};
  loggedInUserName: any;
  selectedYearForAsset: any;
  pmsYears: any = [];
  fromYear: any;
  toYear: any;
  gridApi: any;
  gridColumnApi: any;
  searchTaskString: string = '';
  formatedataVariable = formatText;
  findLogdinUserAsaAuthority: any = false;
  public components: any = {
    assetSelectRenderer: AssetSelectRendererComponent
  };

  public gridContext = { componentParent: this };


  constructor(private toastController: ToastController, private ngZone: NgZone, private datePipe: DatePipe, public dialogRef: MatDialogRef<NewAssetEmployeeComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, private config: Config, private httpService: HttpService, private toastr: ToastrService) {
    this.todayDate = new Date().toISOString().split('T')[0];
    console.log(data);

    this.datedisplay = this.datePipe;
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    console.log("this.updateData", this.updateData);
    if (this.data?.data != null) {
      this.selectedBand = this.updateData?.band;
      this.selectedEmployee = this.updateData?.employeeName;
      // this.selectedAssets = this.updateData?.assetId;
      console.log(this.selectedBand);
    }

  }

  ngOnDestroy(): void {
    try {
      if ((window as any).removeEventListener && this._allocateEventListener) {
        (window as any).removeEventListener('allocate-asset', this._allocateEventListener);
      }
    } catch (e) {
      console.warn('Error removing allocate-asset listener', e);
    }
  }

  /**
   * Handle allocate requests dispatched from renderers when direct access to
   * the component instance isn't available. The renderer dispatches a
   * CustomEvent('allocate-asset', { detail: { rowData } }).
   */
  handleAllocateEvent(rowData: any) {
    if (!rowData) return;
    // find the row index by object reference first, fallback to userId match
    let index = this.AllAssetListingData.findIndex((r: any) => r === rowData);
    if (index === -1 && rowData && rowData.userId !== undefined) {
      index = this.AllAssetListingData.findIndex((r: any) => String(r.userId) === String(rowData.userId));
    }
    if (index === -1) {
      console.warn('allocate-event: could not find row index for dispatched rowData', rowData);
      return;
    }

    // sync selection from the row data into component state
    this.selectedBandformultiple[index] = Array.isArray(rowData._selectedAssets) ? [...rowData._selectedAssets] : [];
    // ensure filteredDataByRow is rebuilt and then call allocation
    this.updateAssetData(rowData);
    this.updateDataByEmployee(index);
  }
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING_ASSET_DUE_TO_EXIT",
    "RECEIVED_AFTER_REPAIR"
  ];

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    console.log(this.loggedInCompanyMDCode);

    this.findLogdinUserAsaAuthority = sessionStorage.getItem('findLogdinUserAsaAuthority');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();

    // Listen for allocate events dispatched from DOM renderers when componentParent isn't available
    (window as any).addEventListener('allocate-asset', this._allocateEventListener = (e: any) => {
      try {
        this.handleAllocateEvent(e.detail?.rowData);
      } catch (err) {
        console.error('allocate-asset listener error', err);
      }
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);




  }
  // --------------------------------------AG - GRID STARTS HERE------------------------------------------
  defaultColDef: ColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 120,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Employee Name',
      field: 'employeeName',
      width: 180,
      cellStyle: {
        overflow: 'hidden',         // Cell hides overflow
        display: 'flex',
        alignItems: 'center'
      }
    },
    {
      headerName: 'Band',
      field: 'band',
      width: 120,
      cellStyle: {
        overflow: 'hidden',         // Cell hides overflow
        display: 'flex',
        alignItems: 'center'
      }
    },
    {
      headerName: 'Asset',
      field: 'unassignedAssets',
      cellRenderer: 'assetSelectRenderer',
      editable: false,
      minWidth: 250,
      cellStyle: {
        overflow: 'hidden',         // Cell hides overflow
        display: 'flex',
        alignItems: 'center'
      }
    }
    , {
      headerName: 'Date of Joining',
      field: 'dateOfJoining',
      cellRenderer: (params: any) => this.dateRenderer(params),
      comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
      filter: 'agDateColumnFilter',
      minWidth: 180,
      filterParams: {
        filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
        suppressAndOrCondition: true,  // ✅ AND/OR hide
        maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
      }, cellStyle: {
        overflow: 'hidden',         // Cell hides overflow
        display: 'flex',
        alignItems: 'center'
      }
    }, {
      headerName: 'Action',
      field: 'actions',
      width: 200,
      cellStyle: {
        overflow: 'hidden',         // Cell hides overflow
        display: 'flex',
        alignItems: 'center'
      },
      cellRenderer: (params: any) => {
        console.log('Action cell renderer params:', params);
        const parent = params.context?.componentParent;

        const wrap = document.createElement('div');
        wrap.style.display = 'flex';
        wrap.style.flexDirection = 'row';
        wrap.style.justifyContent = 'center';
        wrap.style.gap = '10px';
        // wrap.style.padding = '4px';
        wrap.style.alignItems = 'center';

        // ---- Allocate (Tick Icon)
        const btnAlloc = document.createElement('button');
        btnAlloc.className = 'icon-btn tick-btn';
        btnAlloc.title = 'Allocate';
        // btnAlloc.innerHTML = '✅'; // You can also use <i class="fa fa-check"></i> if Font Awesome is included
        btnAlloc.innerHTML = '<ion-icon name="checkmark-outline" aria-hidden="true"></ion-icon>';
        btnAlloc.style.border = 'none';
        btnAlloc.style.cursor = 'pointer';
        btnAlloc.style.fontSize = '18px';
        btnAlloc.style.display = 'flex';
        btnAlloc.style.alignItems = 'center';
        btnAlloc.style.justifyContent = 'center';
        btnAlloc.style.marginTop = '9px';
        // ---- Cancel (Cross Icon)
        const btnCancel = document.createElement('button');
        btnCancel.className = 'icon-btn cancel-btn';
        btnCancel.title = 'Cancel';
        btnCancel.innerHTML = '<ion-icon name="close-outline" aria-hidden="true"></ion-icon>'; // Or <i class="fa fa-times"></i>


        btnCancel.style.border = 'none';
        btnCancel.style.cursor = 'pointer';
        btnCancel.style.color = 'red';
        btnCancel.style.fontSize = '18px';
        btnCancel.style.display = 'flex';
        btnCancel.style.alignItems = 'center';
        btnCancel.style.justifyContent = 'center';
        btnCancel.style.marginTop = '9px';

        // ---- Allocate click (Tick)
        btnAlloc.addEventListener('click', (resp) => {
          const parent = params.context?.componentParent;
          const idx = params.node?.rowIndex;
          if (!parent || idx == null) return;

          const selectedNames = Array.isArray(params.data?._selectedAssets)
            ? params.data._selectedAssets
            : [];

          parent.selectedBandformultiple[idx] = [...selectedNames];

          if (!selectedNames.length) {
            parent.showAssetError[idx] = true;
            parent.showSelectAssetToast && parent.showSelectAssetToast();
            parent.gridApi.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }

          parent.updateAssetData(params.data);
          const fd = parent.filteredDataByRow[idx];

          if (!fd || !Array.isArray(fd.assetIds) || fd.assetIds.length === 0) {
            parent.showAssetError[idx] = true;
            parent.showSelectAssetToast && parent.showSelectAssetToast();
            return;
          }

          parent.updateDataByEmployee(idx);
        });

        // ---- Cancel click (Cross)
        btnCancel.addEventListener('click', () => {
          const idx = params.node?.rowIndex;
          if (!parent || idx == null) return;

          params.data._selectedAssets = [];
          parent.cancelSelectedAsset(idx);

          try {
            const rowNode = parent.gridApi.getDisplayedRowAtIndex(idx);
            const instances = parent.gridApi.getCellRendererInstances({
              rowNodes: [rowNode],
              columns: ['unassignedAssets'],
            });
            if (instances && instances.length > 0) {
              const renderer = (instances[0] as any).componentInstance;
              if (renderer) {
                renderer.selectedAssets = [];
                if (renderer.onChange) renderer.onChange();
              }
            }
          } catch { }

          parent.gridApi.refreshCells({ rowNodes: [params.node], force: true });
        });

        wrap.appendChild(btnAlloc);
        wrap.appendChild(btnCancel);
        return wrap;
      }


    }



  ];
  showSelectAssetToast() {
    this.ngZone.run(() => {
      this.toastr.warning('Please select an asset before allocating!', 'Warning', {
        timeOut: 2500,
        positionClass: 'toast-top-right'
      });
    });
  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    console.log('AG Grid version OK; rows:', this.AllAssetListingData?.length, 'components:', this.components);


    // OPTIONAL: if your data arrives async, refresh when set
    // setTimeout(() => this.gridApi.refreshCells({ force: true }), 0);
  }

  // onCellClicked is unused because action buttons use their own handlers.
  // Keeping a no-op here to avoid duplicate handling via dataset attributes.
  onCellClicked(_ev: any) { return; }
  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  isClicked = false;

  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }





  //---------------------------------------AG - GRID ENDS HERE-------------------------------------------
  selectedAsset: any;



  selectedEmployee: any;
  selectedSubAsset: any;

  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  //   // This function will be triggered when the asset (band) changes
  onAssetChange(event: any) {
    console.log(event);


  }

  //   // This function will be triggered when an employee is selected


  onBandChange(event: any) {
    console.log('Selected Bands:', this.selectedBand); // Log the selected values (array of bands)
    this.selectedBand = event.value;  // Store the selected bands in the array



  }


  onEmployeeChange() {
    console.log(this.selectedBand);

    this.userListDataForAsset.users = this.userListDataForAsset.users.filter((elm: any) => this.selectedBand.includes(elm.band))
    console.log(this.userListDataForAsset);



  }
  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"






  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
      // this.getAllAssetData('bar')
      this.NewassetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForAsset = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      // this.getAllAssetData('bar')
      this.NewassetAllocationData();

    }
  }

  // Triggered when the asset dropdown is clicked
  onAssetClick() {
    console.log('Assets dropdown clicked');
    // You can handle other logic when dropdown is clicked, if needed
  }






  assetManagementHeader = [

    { label: 'Employee Name', isMandatory: false, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: false, sortingName: 'band' },
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: ' Date Of joining', isMandatory: false, sortingName: 'reimbursementType' },


    { label: 'Action', isMandatory: false, sortingName: 'action' },


  ];


  arrBandsForAssets: any = {};
  arrAllocatingDept: any;
  AllAssetListingData: any[] = [];
  getbandListData: any[] = [];
  selectedBandformultiple: any[] = [];
  // Store filtered data per row so each row's selection is kept separately
  filteredDataByRow: { [rowIndex: number]: any } = {};


  // NewassetAllocationData() {


  //   if (this.httpService.checkAuthorityName) {


  //     var arrAllAssetListingData: any = {};
  //     this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}`)
  //       .subscribe((elm: any) => {
  //         const AllAssetListingData = elm.data;
  //         console.log("All Assset List is here.....", AllAssetListingData);

  //         const arrAllAssetData = (this.findLogdinUserAsaAuthority == 'true') ? AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId) : AllAssetListingData;

  //         console.log("Inside the authority....................");

  //         arrAllAssetListingData = [...new Set(arrAllAssetData.flatMap((asset: any) => asset.bands))];


  //       });

  //     this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`)
  //       .subscribe((elm: any) => {

  //         const AllAssetListingData = elm.data.filter((record: any) =>
  //           record.authorityName !== this.loggedInUserName && String(record.userId) !== String(this.loggedInUserId)
  //         );


  //         // const AllAssetListingData = elm.data.filter((record: any) => record.authorityName !== this.loggedInUserName && record.userId !== this.loggedInUserId);

  //         let authorityData = elm.data.filter((elm: any) => elm.authorityName == this.loggedInUserName);
  //         console.log("Authority Data....", authorityData);


  //         this.AllAssetListingData = (this.findLogdinUserAsaAuthority == 'true') ? elm.data.filter((asset: any) => arrAllAssetListingData.includes(asset.band) && String(asset.userId) !== String(this.loggedInUserId)
  //           ): authorityData;

  //         // this.AllAssetListingData = (this.findLogdinUserAsaAuthority == 'true') ? elm.data.filter((asset: any) => arrAllAssetListingData.includes(asset.band) && asset.userId !== this.loggedInUserId): authorityData;

  //         console.log("Authority 123............", this.AllAssetListingData);



  //       })


  //   } else {

  //     this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`)
  //       .subscribe((elm: any) => {
  //         this.AllAssetListingData = elm.data;
  //       console.log("Else part is here .........",   this.AllAssetListingData );

  //         console.log("getbands else part",   this.getbandListData);

  //         this.getbandListData = this.AllAssetListingData.map((ele: any, index: any) => ({
  //           id: index,
  //           name: ele.unassignedAssets,
  //         }));

  //       })
  //   }


  // }
  /** Extract a lowercase set of allocated asset names from whatever field the API provides. */
  /** Try to extract already-allocated asset *names* from an employee object without knowing the exact field name. */
  private extractAllocatedNameSet(_: any): Set<string> {
    return new Set();
  }



  /** Build one row: align names↔ids and drop already-allocated by name. */
  private buildEmployeeRow(emp: any, allowedAssets: Array<{ id: any; name: string }>) {
    // Backend already gives free assets in emp.unassignedAssets
    const backendNames = Array.isArray(emp.unassignedAssets) ? emp.unassignedAssets : [];

    // Map backend free assets to name/id
    const available = allowedAssets.filter(a => backendNames.includes(a.name));

    return {
      ...emp,
      unassignedAssets: available.map(a => a.name),
      assetIds: available.map(a => a.id),
      _selectedAssets: emp._selectedAssets || []
    };
  }




  NewassetAllocationData() {
    if (this.httpService.checkAuthorityName) {
      // ✅ Authority branch
      this.httpService.callGetService(
        `${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}`
      ).subscribe((assetRes: any) => {

        const allAssets = assetRes?.data || [];
        const authorityAssets = allAssets.filter((a: any) => a.authorityName === this.loggedInUserName);
        const authorityBands = [...new Set(authorityAssets.flatMap((a: any) => a.bands))];

        this.httpService.callGetService(
          `${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`
        ).subscribe((empRes: any) => {

          const rawEmployees = empRes?.data || [];

          const filteredEmployees = rawEmployees.filter((emp: any) =>
            authorityBands.includes(emp.band) &&
            String(emp.userId) !== String(this.loggedInUserId)
          );

          const finalEmployeeList = filteredEmployees.map((emp: any) => {
            const matchingAssets = authorityAssets.filter((asset: any) =>
              asset.bands.includes(emp.band)
            );

            const allowedAssets = matchingAssets.map((a: any) => ({
              id: a.assetId ?? a.id,
              name: a.assetName
            }));

            return this.buildEmployeeRow(emp, allowedAssets);
          });

          // ✅ Assign list
          this.AllAssetListingData = finalEmployeeList.map((r: any) => ({
            ...r,
            _selectedAssets: []
          }));

          // ✅ Remove employees with **zero unassigned assets**
          this.AllAssetListingData = this.AllAssetListingData.filter(emp =>
            Array.isArray(emp.unassignedAssets) && emp.unassignedAssets.length > 0
          );

          this.selectedBandformultiple = this.AllAssetListingData.map(() => []);
          this.filteredDataByRow = {};
          this.showAssetError = [];
        });
      });

    } else {
      // ✅ Non-authority branch
      this.httpService.callGetService(
        `${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset}/${this.loggedInUserCompanyID}`
      ).subscribe((elm: any) => {

        const employees = elm?.data || [];

        this.AllAssetListingData = employees.map((emp: any) => {
          const names: string[] = Array.isArray(emp.unassignedAssets) ? emp.unassignedAssets : [];
          const ids: any[] = Array.isArray(emp.assetIds)
            ? emp.assetIds
            : names.map((_: any, i: any) => i);

          const allowedAssets = names.map((n: any, i: any) => ({
            name: n, id: ids[i]
          }));

          return this.buildEmployeeRow(emp, allowedAssets);
        });

        // ✅ Remove employees who have no unassigned assets
        this.AllAssetListingData = this.AllAssetListingData.filter(emp =>
          Array.isArray(emp.unassignedAssets) && emp.unassignedAssets.length > 0
        );

        this.selectedBandformultiple = this.AllAssetListingData.map(() => []);
        this.filteredDataByRow = {};
        this.showAssetError = [];
      });
    }
  }





  filterBandByAsset(asset: string) {
    // Replace this with your logic to filter bands based on the asset
    console.log(asset);

    return this.getbandListData.filter((band: any) => band.band === asset);
  }

  assets: any = [];
  allUsers: any[] = [];


  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];




  filteredData: any;

  updateAssetData(data: any) {
    const index = this.AllAssetListingData.findIndex(emp => emp === data);

    const selectedNames: string[] = Array.isArray(data?._selectedAssets)
      ? data._selectedAssets
      : (this.selectedBandformultiple[index] || []);

    if (!selectedNames.length) {
      delete this.filteredDataByRow[index];
      this.showAssetError[index] = true;
      return;
    }

    this.showAssetError[index] = false;

    const names: string[] = Array.isArray(data?.unassignedAssets) ? data.unassignedAssets : [];
    const ids: any[] = Array.isArray(data?.assetIds) ? data.assetIds : [];

    const nameToId = new Map(names.map((n, i) => [n, ids[i]]));

    const filteredIds = selectedNames.map(n => nameToId.get(n)).filter(v => v != null);

    this.filteredDataByRow[index] = {
      ...data,
      unassignedAssets: selectedNames,
      assetIds: filteredIds,
      _selectedAssets: selectedNames
    };

    console.log("Mapped:", { row: index, selectedNames, filteredIds });
  }





  showAssetError: boolean[] = [];
  selecteAsset: boolean[] = [];
  updateDataByEmployee(index: number) {
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    const row = rowNode?.data || {};

    // ✅ Read selection from row (NOT from arrays)
    const selected: string[] = Array.isArray(row._selectedAssets) ? [...row._selectedAssets] : [];

    if (!selected.length) {
      this.showAssetError[index] = true;
      this.ngZone.run(() => this.toastr.warning("Please select asset before allocating"));
      return;
    }
    this.showAssetError[index] = false;

    const names: string[] = Array.isArray(row.unassignedAssets) ? row.unassignedAssets : [];
    const ids: any[] = Array.isArray(row.assetIds) ? row.assetIds : [];

    // ✅ Convert selected names → IDs
    const selectedIds = names
      .map((n: string, i: number) => selected.includes(n) ? ids[i] : null)
      .filter((v: any) => v !== null);

    const formData = {
      userId: row.userId,
      assetIds: selectedIds,
      companyId: this.loggedInUserCompanyID,
    };

    // ✅ Success toast instantly
    this.ngZone.run(() => this.toastr.info("Allocating..."));

    this.httpService.callPostService(`${this.config.multipleAssetsnewJoiningEmployee}`, formData)
      .subscribe({
        next: (result: any) => {
          this.ngZone.run(() => this.toastr.success(result?.message || "Assets Allocated"));

          const remainingNames = names.filter((n: string) => !selected.includes(n));
          const remainingIds = remainingNames.map((n: string) => ids[names.indexOf(n)]);

          row._selectedAssets = [];

          // ✅ If no assets left → remove row
          if (!remainingNames.length) {
            this.AllAssetListingData = this.AllAssetListingData.filter((e: any) => e.userId !== row.userId);
            this.gridApi.applyTransaction({ remove: [row] });
            return;
          }

          rowNode.setData({
            ...row,
            unassignedAssets: remainingNames,
            assetIds: remainingIds,
            _selectedAssets: []
          });

          this.gridApi.refreshCells({
            rowNodes: [rowNode],
            columns: ['unassignedAssets'],
            force: true
          });

          // ✅ Reset dropdown UI
          const instances = this.gridApi.getCellRendererInstances({
            rowNodes: [rowNode],
            columns: ['unassignedAssets']
          });

          instances.forEach((inst: any) => {
            const cmp = inst.componentInstance;
            if (cmp) {
              cmp.selectedAssets = [];
              cmp.onChange?.();
            }
          });
        },

        error: (err) => {
          const msg = err?.error?.message || "";

          if (/already allocated/i.test(msg)) {
            this.ngZone.run(() =>
              this.toastr.info("Some assets were already allocated — list updated", "Info")
            );

            const remainingNames = names.filter((n: string) => !selected.includes(n));
            const remainingIds = remainingNames.map((n: string) => ids[names.indexOf(n)]);

            if (!remainingNames.length) {
              this.AllAssetListingData = this.AllAssetListingData.filter((e: any) => e.userId !== row.userId);
              this.gridApi.applyTransaction({ remove: [row] });
              return;
            }

            rowNode.setData({
              ...row,
              unassignedAssets: remainingNames,
              assetIds: remainingIds,
              _selectedAssets: []
            });

            this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
            return;
          }

          this.ngZone.run(() => this.toastr.error("Allocation failed — Try again.", "Error"));
        }
      });
  } 
  
  cancelSelectedAsset(index: number) {
    // this.selecteAsset=false;
    this.selectedBandformultiple[index] = [];
    this.showAssetError[index] = false;
    // clear per-row filtered data
    delete this.filteredDataByRow[index];
  }

  cancelData() {
    // Listen to the result and then perform actions
    this.dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed with result:', result);
      // Perform any additional logic based on the result
    });

    // Close the dialog
    this.dialogRef.close();
  }

}





